import { InfrigmentOfUser } from '@/interfaces/infractions';
import { Person } from '@/interfaces/person';
import { DriverService } from '@/services/driver/driver.service';
import { InfractionService } from '@/services/infraction/infraction.service';
import { PersonService } from '@/services/person/person.service';
import { BoxColors } from '@/shared/person-card/person-card.component';
import { Option } from '@/shared/select-list/select-list.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-form-select-person',
  templateUrl: './form-select-person.component.html',
  styleUrls: ['./form-select-person.component.css'],
})
export class FormSelectPersonComponent implements OnInit {

  @Input() controlForm: FormGroup = new FormGroup({
    id: new FormControl(0, [Validators.required, Validators.min(1)]),
    email: new FormControl('', [Validators.required]),
    mdmid: new FormControl('', [Validators.required]),
  });

  @Output() resetForm = new EventEmitter();

  backColor: BoxColors = BoxColors.WHITE;
  personForm: FormGroup = new FormGroup({
    filterText: new FormControl(''),
    id: new FormControl(-1),
  });

  listPersonOptions: Option[] = [];
  loadingPersonOptions: boolean = false;

  selectedPersonData?: Person;
  infractionsData?: InfrigmentOfUser[] = undefined;
  getInfractionsDataError: boolean = false;

  gettingDataOfPerson: boolean = false;

  constructor(
    private driverService: DriverService,
    private personService: PersonService,
    private infractionsService: InfractionService,
  ) {

    const {
      filterText: filterText$,
    } = this.personForm.controls;

    filterText$.valueChanges
      .pipe(
        tap(() => {
          this.loadingPersonOptions = true;
        }),
        debounceTime(2000),
        switchMap((value) => this.driverService.getFilteredList(value)),
      )
      .subscribe({
        next: (options) => {
          this.loadingPersonOptions = false;
          this.listPersonOptions = options;
        },
      });

  }

  ngOnInit() {
    this.controlForm.controls.id.valueChanges.subscribe({
      next: (value) => {
        if (value === null) {
          this.selectedPersonData = undefined;
        }
        else if (!this.selectedPersonData && !this.gettingDataOfPerson) {
          this.gettingDataOfPerson = true;
          this.personService.getPersonDataById(value).subscribe({
            next: (personData) => {
              this.gettingDataOfPerson = false;
              this.selectedPersonData = personData;
              this.getInfractionsBySelectedUser(this.selectedPersonData.mdmid);
            },
          });
        }
      },
    });
  }

  getInfractionsBySelectedUser(mdmid: string) {
    this.infractionsService.getInfringementsByUser(mdmid)
      .subscribe({
        next: (infringementData) => {
          this.infractionsData = infringementData.slice(0, 2).sort((a, b) => {
            const aParam = a.dateRegister.split('-').join('');
            const bParam = b.dateRegister.split('-').join('');
            if (aParam > bParam) {
              return -1;
            }
            if (aParam < bParam) {
              return 1;
            }
            return 0;
          });
        },
        error: () => {
          this.getInfractionsDataError = true;
        },
      });
  }

  onSearchPersonTextChange(text: string) {
    this.personForm.patchValue({ filterText: text });
  }

  onSearchPersonSelected(id: string) {
    this.personForm.patchValue({ id: +id });
  }

  onSelectPerson() {
    const personId = this.personForm.controls.id.value;
    this.gettingDataOfPerson = true;
    this.personService.getPersonDataById(personId).subscribe({
      next: (personData) => {
        this.gettingDataOfPerson = false;
        this.selectedPersonData = personData;
        this.controlForm.controls.id.patchValue(personId);
        this.controlForm.controls.email.patchValue(personData.email);
        this.controlForm.controls.mdmid.patchValue(personData.mdmid);
        this.getInfractionsBySelectedUser(this.selectedPersonData.mdmid);
      },
    });
  }

  onUnselect() {
    this.personForm.patchValue({ id: 0, filterText: '' });
    this.controlForm.controls.id.patchValue(0);
    this.controlForm.controls.email.patchValue('');
    this.controlForm.controls.mdmid.patchValue('');
    this.selectedPersonData = undefined;
    this.listPersonOptions = [];
    this.infractionsData = undefined;
    this.resetForm.emit('');
  }

}
